import { transform } from '@utils/intl_lang'
// 实践培训项目导航栏
export const rightTag = [
  // '学员'
  { key: 'traineePlanTask', name: transform('practiceTrain_student') },
  // '指导员'
  { key: 'mentorPlanTask', name: transform('practiceTrain_instructor') },
  // '主管'
  { key: 'managerPlanTask', name: transform('practiceTrain_manager') },
  // '部门长'
  {
    key: 'directorPlanTask',
    name: transform('practiceTrain_director_plan_task'),
  },
]

// 实践培训项目数据
export const identList = {
  // 学员
  traineePlanTask:
    // [{ title: '试用期工作记录表', textName: '', fillCard: '查看指导人安排的阶段工作规划', code: 'probationCard' },
    [
      {
        title: transform('practiceTrain_train_title01'),
        textName: '',
        fillCard: transform('practiceTrain_train_fillCard01'),
        code: 'probationCard',
      },
      // { title: '日报（新人每日总结）', textName: '', fillCard: '培训过程中需填写日报', code: 'dateCard' },
      {
        title: transform('practiceTrain_train_title02'),
        textName: '',
        fillCard: transform('practiceTrain_train_fillCard02'),
        code: 'dateCard',
      },
      // { title: '周报（新人每周总结）', textName: '', fillCard: '培训过程中需要填写周报', code: 'weekCard' },
      {
        title: transform('practiceTrain_train_title03'),
        textName: '',
        fillCard: transform('practiceTrain_train_fillCard03'),
        code: 'weekCard',
      },
      // { title: '月报（面谈跟踪记录表）', textName: '', fillCard: '培训过程中需要填月报', code: 'monthCard' },
      {
        title: transform('practiceTrain_mentor_title05'),
        textName: '',
        fillCard: transform('practiceTrain_train_fillCard04'),
        code: 'monthCard',
      },
      // { title: '指导人评价表', textName: '', fillCard: '请填写对指导人的评价', code: 'evaluateCard' }],
      {
        title: transform('practiceTrain_train_title05'),
        textName: '',
        fillCard: transform('practiceTrain_train_fillCard05'),
        code: 'evaluateCard',
      },
    ],
  // 指导员
  mentorPlanTask:
    // [{ title: '指导人任务清单', textName: '', fillCard: '需指导人分阶段填报任务完成情况', code: 'taskCard' },
    [
      {
        title: transform('practiceTrain_mentor_title01'),
        textName: '',
        fillCard: transform('practiceTrain_mentor_fillCard01'),
        code: 'taskCard',
      },
      // { title: '试用期工作记录表', textName: '', fillCard: '需指导人对学员填写工作计划', code: 'probationCard' },
      {
        title: transform('practiceTrain_mentor_title02'),
        textName: '',
        fillCard: transform('practiceTrain_mentor_fillCard02'),
        code: 'probationCard',
      },
      // { title: '日报（新人每日总结）', textName: '', fillCard: '查看学员提交的日报', code: 'dateCard' },
      {
        title: transform('practiceTrain_mentor_title03'),
        textName: '',
        fillCard: transform('practiceTrain_mentor_fillCard03'),
        code: 'dateCard',
      },
      // { title: '周报（新人每周总结）', textName: '', fillCard: '查看学员提交的周报', code: 'weekCard' },
      {
        title: transform('practiceTrain_mentor_title04'),
        textName: '',
        fillCard: transform('practiceTrain_mentor_fillCard04'),
        code: 'weekCard',
      },
      // { title: '月报（面谈跟踪记录表）', textName: '', fillCard: '需指导人填写学员报评价', code: 'monthCard' },
      {
        title: transform('practiceTrain_mentor_title05'),
        textName: '',
        fillCard: transform('practiceTrain_mentor_fillCard05'),
        code: 'monthCard',
      },
      // { title: '转正考核表', textName: '', fillCard: '需指导员填写学员转正意见', code: 'examineCard' }],
      {
        title: transform('practiceTrain_director_title02'),
        textName: '',
        fillCard: transform('practiceTrain_mentor_fillCard06'),
        code: 'examineCard',
      },
    ],
  // 主管
  managerPlanTask:
    // [{ title: '月报（面谈跟踪记录表）', textName: '', fillCard: '审阅学员提交的月报与指导人意见', code: 'monthCard' }],
    [
      {
        title: transform('practiceTrain_manager_title01'),
        textName: '',
        fillCard: transform('practiceTrain_director_fillCard01'),
        code: 'monthCard',
      },
    ],
  // 部长
  directorPlanTask:
    // [{ title: '月报（面谈跟踪记录表）', textName: '', fillCard: '审阅学员提交的月报与指导人意见', code: 'monthCard' },
    [
      {
        title: transform('practiceTrain_manager_title01'),
        textName: '',
        fillCard: transform('practiceTrain_director_fillCard01'),
        code: 'monthCard',
      },
      // { title: '转正考核表', textName: '', code: 'examineCard', fillCard: '需部门长填写学员转正意见', }]
      {
        title: transform('practiceTrain_director_title02'),
        textName: '',
        code: 'examineCard',
        fillCard: transform('practiceTrain_director_fillCard02'),
      },
    ],
}

export const myTestTag = [
  // { key: 'traineePlanTask', name: '学员', value: 0 },
  {
    key: 'traineePlanTask',
    name: transform('practiceTrain_student'),
    value: 0,
  },
  // { key: 'mentorPlanTask', name: '指导员', value: 1 },
  {
    key: 'mentorPlanTask',
    name: transform('practiceTrain_instructor'),
    value: 1,
  },
  // { key: 'managerPlanTask', name: '主管', value: 2 },
  {
    key: 'managerPlanTask',
    name: transform('practiceTrain_manager'),
    value: 2,
  },
]
export const myTestList = {
  // 学员
  traineePlanTask:
    //  [{ title: '学员发展计划表-', textName: '', fillCard: '培训期间每个阶段填报发展计划与反思', code: 'developPlanCard' },
    [
      {
        title: transform('practiceTrain_train02_title01'),
        textName: '',
        fillCard: transform('practiceTrain_train02_fillCard01'),
        code: 'developPlanCard',
      },
      //  { title: '学员发展计划表-', textName: '', fillCard: '培训期间每个阶段填报发展计划与反思', code: 'developFirstStepCard' },
      {
        title: transform('practiceTrain_train02_title02'),
        textName: '',
        fillCard: transform('practiceTrain_train02_fillCard02'),
        code: 'developFirstStepCard',
      },
      //  { title: '学员发展计划表-', textName: '', fillCard: '培训期间每个阶段填报发展计划与反思', code: 'developAllStepCard' }],
      {
        title: transform('practiceTrain_train02_title03'),
        textName: '',
        fillCard: transform('practiceTrain_train02_fillCard03'),
        code: 'developAllStepCard',
      },
    ],
  // 指导员
  mentorPlanTask:
    //  [{ title: '学员发展计划表-', textName: '', fillCard: '需指导人对学员计划填写评价', code: 'developFirstStepCard' },
    [
      {
        title: transform('mentor02_title01'),
        textName: '',
        fillCard: transform('mentor02_fillCard01'),
        code: 'developFirstStepCard',
      },
      //  { title: '学员发展计划表-', textName: '', fillCard: '需指导人对学员计划填写评价', code: 'developAllStepCard' }],
      {
        title: transform('mentor02_title02'),
        textName: '',
        fillCard: transform('mentor02_fillCard02'),
        code: 'developAllStepCard',
      },
    ],
  // 主管
  managerPlanTask:
    //  [{ title: '主管评价表（前测）', textName: '', fillCard: '需主管在培训前对学员填写评价', code: 'evaluateBeforeCard' },
    [
      {
        title: transform('manager02_title01'),
        textName: '',
        fillCard: transform('manager02_fillCard01'),
        code: 'evaluateBeforeCard',
      },
      //  { title: '主管评价表（后测）', textName: '', fillCard: '需主管在培训后对学员填写评价', code: 'evaluateAfterCard' }]
      {
        title: transform('manager02_title02'),
        textName: '',
        fillCard: transform('manager02_fillCard03'),
        code: 'evaluateAfterCard',
      },
    ],
}

interface RouteParams {
  roleType: number
  idMlnEmp: string
  idPracticalTraining: string
  mentorIdMlnEmp?: string
  managerIdMlnEmp?: string
  directorIdMlnEmp?: string
}
// 实践培训任务列表
export interface IItem {
  /** key值 */
  code: string
  /** 第二个字段（指导人姓名和培训时间） */
  textName: string
  /** 第三个字段（培训过程过需要填写周报） */
  fillCard: string
  /** 培训名称 */
  title: string
}

// 个人发展计划
export interface IItemDev {
  /** key值 */
  code: string
  /** 第二个字段（指导人姓名和培训时间） */
  textName: string
  /** 第三个字段（培训过程过需要填写周报） */
  fillCard: string
  /** 培训名称 */
  title: string
}

export const routeParams = ({
  roleType,
  idMlnEmp,
  idPracticalTraining,
  mentorIdMlnEmp,
}: RouteParams) => {
  const str =
    roleType === 0 ? `idMlnEmp=${idMlnEmp}` : `mentorIdMlnEmp=${mentorIdMlnEmp}`
  return `?idPracticalTraining=${idPracticalTraining}&${str}`
}

export const fixId = ({
  roleType,
  idMlnEmp,
  idPracticalTraining,
  mentorIdMlnEmp,
  managerIdMlnEmp,
  directorIdMlnEmp,
}: RouteParams) => {
  let str = ``
  switch (roleType) {
    case 0:
      str = `id=${idMlnEmp}`
      break
    case 1:
      str = `id=${mentorIdMlnEmp}`
      break
    case 2:
      str = `id=${managerIdMlnEmp}`
      break
    default:
      str = `id=${directorIdMlnEmp}`
      break
  }
  return `?idPracticalTraining=${idPracticalTraining}&roleType=${roleType}&${str}`
}

// 从localStorage中获取面包屑上的字段
export const getTrainName = () => {
  return localStorage.getItem('trainingName') || ''
}
